<template>
    <a-modal
      v-model="isMaintainer"
      destroyOnClose
      :footer="null"
      :maskClosable="false"
      :closable="false"
      :width="700"
      centered
    >
      <div class="toMaintainer">
        <div class="title">
          <a-icon @click="close" style="font-size: 16px; cursor: pointer" type="close" />
          <span>请选择维护人</span>
          <span style="font-size: 16px; color: var(--ThemeColor); cursor: pointer" @click="handleOk">提交</span>
        </div>
        <div class="content">
          <!-- <a-select class="one" placeholder="部门" v-model="maintainer.deptId" @change="chooseDept">
            <a-select-option :value="item.deptId" v-for="item in dept" :key="item.deptId"
              >{{ item.deptName }}
            </a-select-option>
          </a-select> -->
          <a-tree-select
            v-model="maintainer.deptId"
            style="width: 40%"
            :tree-data="deptOptions"
            placeholder="请选择人员团队名称"
            :replaceFields="replaceFields"
            tree-default-expand-all
            @change="handleChangeTreeeMain"
          ></a-tree-select>
          -
          <a-select
            v-model="maintainer.accendantId"
            @dropdownVisibleChange="handleOptiontourist_maintainer($event)"
            placeholder="请选择人员名称"
            style="width: 30%"
          >
            <a-select-option v-for="item in userList" :key="item.userId" :value="item.userId">
              {{ item.nickName }}
            </a-select-option>
          </a-select>
        </div>
      </div>
    </a-modal>
</template>

<script>
import touristApi from '@/api/system/tourist/tourist.js'
import sell_touristApi from '@/api/system/tourist/sell_tourist.js'

import { treeSelectMixin } from '@/mixin/treeSelect'

export default {
    props:{
        // userList:{
        //     type:Array,
        //     default:()=>[]
        // }
        type:{
          type:String,
          default:''
        }
    },
    watch:{
        // userList:{
        //     handler(){},
        //     deep:true,
        //     immediate:true
        // }
    },
    mixins: [treeSelectMixin],
    data(){
        return {
            isMaintainer:false,
            // 转维护人接口参数
            maintainer: {
                accendantId: undefined,
                deptId: undefined,
                id: this.$route.query.id
            },
        }
    },
    methods:{
        open(){
            this.isMaintainer = true
        },
        close(){
            this.isMaintainer = false 
            this.maintainer.accendantId = undefined
            this.maintainer.deptId = undefined
        },
        // 转为维护人提交
        handleOk () {
            if (
                this.maintainer.accendantId === undefined ||
                this.maintainer.deptId === undefined ||
                this.maintainer.id === undefined
            ) {
                this.$message.error('您还未完成选择')
            } else {
              let port = this.type === 'sale'? sell_touristApi: touristApi
                port.toMaintainer({ ...this.maintainer }).then((res) => {
                    if (res.code === 200) {
                        this.$message.success('转维护人成功')
                        this.close()
                        // this.getUserInfo()
                        // this.getPersonList()
                        this.$emit('onSuccess')
                    }
                })
            }
        },
    }
}
</script>

<style lang="less" scoped>
//转维护人 弹窗
.toMaintainer {
  height: 360px;
  .title {
    height: 20px;
    line-height: 20px;
    color: #000;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
  }
  .content {
    margin: 100px 0;
    text-align: center;
    .one {
      width: 200px;
    }
  }
}
</style>